import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import VnButton from '@ui/components/VnButton';
import VnGridHeader from '@ui/components/VnGrid/VnGridHeader';
import { addOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ApprovedDebtorTable from './ApprovedDebtorTable';
import PendingDebtorTable from './PendingDebtorTable';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnPagination from '@ui/components/VnPagination';
import { getAllApprovedDebtorsAsync, getAllDisapprovedDebtorsAsync, getAllPendingDebtorsAsync } from '@application/features/debtors/debtorThunk';
import VnDocumentTitle from '@ui/components/VnDocumentTitle';
import { Permission, PermissionType } from '@application/common/enums/role-permission';
import { handleRolePermission } from '@infrastructure/helpers';
import DisapprovedDebtorTable from './DisapprovedDebtorTable';
const Debtor = () => {
    VnDocumentTitle('Visser Klanten');
    const [activeTab, setActiveTab] = useState('ApprovedDebtor');
    const [searchPendingDebtorsText, setSearchPendingDebtorsText] = useState('');
    const defaultSortingCriteria = {
        sortColumnKey: 'debtorNumber',
        sortDirection: 'desc'
    };
    const defaultApprovedFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        name: null,
        name2: null,
        address: null,
        postalCode: null,
        city: null,
        phoneNumber: null,
        fax: null,
        debtorNumber: null
    };
    const defaultPendingFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        name: null,
        name2: null,
        address: null,
        postalCode: null,
        city: null,
        phoneNumber: null,
        fax: null,
        debtorNumber: null
    };
    const defaultDisapproveFilterValues = {
        pageNumber: 1,
        pageSize: 30,
        sortColumnKey: defaultSortingCriteria.sortColumnKey,
        sortDirection: defaultSortingCriteria.sortDirection,
        name: null,
        name2: null,
        address: null,
        postalCode: null,
        city: null,
        phoneNumber: null,
        fax: null,
        debtorNumber: null
    };
    const [ApprovedFilterValues, setApprovedFilterValues] = useState(defaultApprovedFilterValues);
    const [pendingFilterValues, setPendingFilterValues] = useState(defaultPendingFilterValues);
    const [disapproveFilterValues, setDisapproveFilterValues] = useState(defaultDisapproveFilterValues);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { approvedDebtors, debtorsRequest, pendingDebtors, disapprovedDebtors } = useAppSelector((state) => state.debtors);
    useEffect(() => {
        if (activeTab === 'ApprovedDebtor') {
            setApprovedFilterValues(defaultApprovedFilterValues);
            dispatch(getAllApprovedDebtorsAsync(defaultApprovedFilterValues));
        }
        else if (activeTab === 'PendingDebtor') {
            setPendingFilterValues(defaultPendingFilterValues);
            dispatch(getAllPendingDebtorsAsync(defaultPendingFilterValues));
        }
        else if (activeTab == 'DisapproveDebtor') {
            setDisapproveFilterValues(defaultPendingFilterValues);
            dispatch(getAllDisapprovedDebtorsAsync(defaultPendingFilterValues)); //change it to disapproved
        }
    }, [dispatch, activeTab]);
    // useEffect(()=>{
    //     dispatch(getAllApprovedDebtorsAsync(ApprovedFilterValues));
    // },[])
    const handleAddDebtorClick = () => {
        navigate(`/admin/DebtorTabs`);
    };
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    /*Approved filtering and Sorting Region*/
    const updateApprovedFilterValues = (newValues) => {
        setApprovedFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchApprovedDebtorsHandler(searchText) {
        updateApprovedFilterValues({ filter: searchText });
        dispatch(getAllApprovedDebtorsAsync({
            ...ApprovedFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function onApprovedDebtorsPageChange(pageNumber) {
        updateApprovedFilterValues({ pageNumber });
        dispatch(getAllApprovedDebtorsAsync({
            ...ApprovedFilterValues,
            pageNumber
        }));
    }
    function ApprovedSortingHandler(data) {
        updateApprovedFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllApprovedDebtorsAsync({
            ...ApprovedFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function ApprovedFilteringHandler(data) {
        data.pageNumber = 1;
        updateApprovedFilterValues(data);
        dispatch(getAllApprovedDebtorsAsync({
            ...ApprovedFilterValues,
            ...data
        }));
    }
    /*Approved filtering and Sorting Region*/
    const updatePendingFilterValues = (newValues) => {
        setPendingFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchPendingDebtorsHandler(searchText) {
        updatePendingFilterValues({ filter: searchText });
        dispatch(getAllPendingDebtorsAsync({
            ...pendingFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
        // setSearchPendingDebtorsText(searchText);
        // dispatch(
        //     getAllPendingDebtorsAsync({
        //         ...debtorsRequest,
        //         filter: searchText
        //     })
        // );
    }
    function onPendingDebtorsPageChange(pageNumber) {
        updatePendingFilterValues({ pageNumber });
        dispatch(getAllPendingDebtorsAsync({
            ...pendingFilterValues,
            pageNumber
        }));
        // dispatch(
        //     getAllPendingDebtorsAsync({
        //         ...debtorsRequest,
        //         pageNumber: pageNumber,
        //         filter: searchPendingDebtorsText
        //     })
        // );
    }
    function pendingDebtorsSortingHandler(data) {
        updatePendingFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllPendingDebtorsAsync({
            ...pendingFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function pendingDebtorFilteringHandler(data) {
        data.pageNumber = 1;
        updatePendingFilterValues(data);
        dispatch(getAllPendingDebtorsAsync({
            ...pendingFilterValues,
            ...data
        }));
    }
    const onRowClick = (rowId) => {
        window.open(`/admin/DebtorTabs/${rowId}`, '_blank');
    };
    /*Disapprove filtering and Sorting Region*/
    const updateDisapproveFilterValues = (newValues) => {
        setDisapproveFilterValues((prevValues) => ({
            ...prevValues,
            ...newValues
        }));
    };
    function searchDisapproveDebtorsHandler(searchText) {
        updateDisapproveFilterValues({ filter: searchText });
        dispatch(getAllDisapprovedDebtorsAsync({
            ...disapproveFilterValues,
            filter: searchText,
            pageNumber: 1
        }));
    }
    function onDisapproveDebtorsPageChange(pageNumber) {
        updateDisapproveFilterValues({ pageNumber });
        dispatch(getAllDisapprovedDebtorsAsync({
            ...disapproveFilterValues,
            pageNumber
        }));
    }
    function DisapproveDebtorsSortingHandler(data) {
        updateDisapproveFilterValues({
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        });
        dispatch(getAllDisapprovedDebtorsAsync({
            ...disapproveFilterValues,
            sortColumnKey: data.sortColumnKey,
            sortDirection: data.sortDirection
        }));
    }
    function DisapproveDebtorFilteringHandler(data) {
        data.pageNumber = 1;
        updateDisapproveFilterValues(data);
        dispatch(getAllDisapprovedDebtorsAsync({
            ...disapproveFilterValues,
            ...data
        }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginRight: 'auto',
                    marginLeft: '0rem',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                }, children: [_jsx("h4", { children: "Klanten" }), _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Klanten', onClick: handleAddDebtorClick, isDisabled: !handleRolePermission(Permission.KLANTEN, PermissionType.Create) }) })] }), _jsxs(Tabs, { activeKey: activeTab, onSelect: handleTabChange, className: 'vn-TabHeader', children: [_jsx(Tab, { eventKey: 'ApprovedDebtor', title: 'Goedgekeurd' }), _jsx(Tab, { eventKey: 'PendingDebtor', title: 'In behandeling' }), _jsx(Tab, { eventKey: 'DisapproveDebtor', title: 'Vervallen' })] }), _jsxs("div", { className: 'mt-0', children: [activeTab === 'ApprovedDebtor' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchApprovedDebtorsHandler }), _jsx(ApprovedDebtorTable, { approvedDebtors: approvedDebtors?.items, onRowClick: onRowClick, onSorting: ApprovedSortingHandler, onFilter: ApprovedFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: approvedDebtors && (_jsx(VnPagination, { currentPage: approvedDebtors?.pageNumber, totalPages: approvedDebtors?.totalPages, onPageChange: onApprovedDebtorsPageChange })) })] })), activeTab === 'PendingDebtor' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchPendingDebtorsHandler }), _jsx(PendingDebtorTable, { pendingDebtors: pendingDebtors?.items, onRowClick: onRowClick, onSorting: pendingDebtorsSortingHandler, onFilter: pendingDebtorFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: pendingDebtors && (_jsx(VnPagination, { currentPage: pendingDebtors?.pageNumber, totalPages: pendingDebtors?.totalPages, onPageChange: onPendingDebtorsPageChange })) })] })), activeTab === 'DisapproveDebtor' && (_jsxs(_Fragment, { children: [_jsx(VnGridHeader, { showSearch: true, onSearch: searchDisapproveDebtorsHandler }), _jsx(DisapprovedDebtorTable, { disapprovedDebtors: disapprovedDebtors?.items, onRowClick: onRowClick, onSorting: DisapproveDebtorsSortingHandler, onFilter: DisapproveDebtorFilteringHandler, defaultSortingCriteria: defaultSortingCriteria }), _jsx("div", { className: 'mt-3', children: disapprovedDebtors && (_jsx(VnPagination, { currentPage: disapprovedDebtors?.pageNumber, totalPages: disapprovedDebtors?.totalPages, onPageChange: onDisapproveDebtorsPageChange })) })] }))] })] }));
};
export default Debtor;
